import * as React from 'react';

export type InfoProps = {
	label?: string;
	text?: string;
	modifier?: string;
};

const Info = ({ label, modifier, text }: InfoProps) => {
	return (
		<div className={`a-info${modifier ? ` a-info--${modifier}` : ''}`}>
			<span className="a-info__label">{label}</span>
			{text && <span className="a-info__text">{text}</span>}
		</div>
	);
};

export default Info;
